export default __webpack_public_path__ + "125dc5bb1423ae6641d22c3943b448b2.jpg";